
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class AuroraBorealisEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const bands = Math.floor(5 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;

        const draw = () => {
            for (let i = 0; i < bands; i++) {
                ctx.save();
                ctx.globalAlpha *= 0.1 / (layerIndex + 1);
                ctx.lineWidth = (50 + i * 20) * scale;
                ctx.beginPath();
                ctx.moveTo(-width * 2, -height * 0.5 + i * 100);
                for (let x = -width * 2; x <= width * 2; x += 50) {
                    const y = -height * 0.5 + i * 100 + Math.sin(x * 0.002 + curTime * 0.5 + i) * 200 * scale;
                    ctx.lineTo(x, y);
                }
                ctx.stroke();
                ctx.restore();
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
